export enum ServiceSelectionDataHooks {
  CTA = 'service-selection-button',
  MobileDrawer = 'service-selection-mobile-drawer',
  Popover = 'service-selection-popover',
  ServicesActionMenu = 'service-selection-services-action-menu',
  ServicesContainer = 'service-selection-services-container',
}
